import { Outlet } from 'react-router-dom';
import { TournamentBySlugProvider } from '../state/TournamentContext';

/**
 * Parent route for `/e/:slug/...`. Resolves the tournament by URL slug and
 * provides it through `TournamentContext` so all public tabs (Stands,
 * Schedule, Locker Room, Front Desk, "My ..." personalization) read from a
 * single source.
 *
 * The PublicShell (rendered by `<AppShell />` upstream) already drew the
 * event header + tab strip — this page just provides context + outlet.
 */
export function EventLandingPage() {
  return (
    <TournamentBySlugProvider>
      <Outlet />
    </TournamentBySlugProvider>
  );
}
